export const TeamAnalyticsHeader = () => {
  return (
    <header className="flex justify-between items-center mb-header-mb">
      <h1 className="text-brand-primary text-3xl font-space-grotesk font-bold">Team Analytics</h1>
      <div className="flex items-center gap-4">
        <div className="relative w-72">
          <input 
            type="text" 
            placeholder="Search team members..." 
            className="w-full h-[38px] pl-4 pr-10 bg-brand-secondary rounded-[20px] text-xs text-brand-text-secondary focus:outline-none focus:ring-2 focus:ring-brand-accent"
          />
          <i className="fa-solid fa-magnifying-glass text-brand-text-secondary absolute right-4 top-1/2 -translate-y-1/2"></i>
        </div>
        <div className="flex items-center gap-2.5">
          <button className="w-[38px] h-[38px] relative bg-brand-secondary rounded-full flex items-center justify-center">
            <i className="fa-regular fa-comment-dots text-lg text-brand-primary"></i>
          </button>
          <button className="w-[38px] h-[38px] relative bg-brand-secondary rounded-full flex items-center justify-center">
            <i className="fa-regular fa-bell text-lg text-brand-primary"></i>
            <div className="absolute top-1 right-1 w-2 h-2 bg-brand-danger rounded-full border-2 border-brand-secondary"></div>
          </button>
        </div>
        <div className="flex items-center gap-3.5">
          <div className="text-right">
            <p className="text-brand-primary text-base font-medium leading-5">Anna Schmid</p>
            <p className="text-xs text-brand-text-secondary">Managing Partner</p>
          </div>
          <img 
            src="https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-1.jpg" 
            alt="User Avatar" 
            className="w-[38px] h-[38px] rounded-full"
          />
        </div>
      </div>
    </header>
  );
};